<template>
  <v-card flat class="media-file-btn" :width="block ? '100%' : undefined">
    <input
      ref="mediaInput"
      type="file"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      @change="uploadFile"
    >
    <v-text-field
      class="media-text-field"
      :prepend-icon="prependIcon"
      v-model="fileName"
      :label="label"
      :disabled="disabled"
      @click="showFileSelector"
      :outline="outline"
      v-bind="$attrs"
    ></v-text-field>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: File,
      default: null
    },
    accept: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {// v-text-field
      type: String,
      default: "Browse"
    },
    color: {// ?
      type: String,
      default: "primary"
    },
    outline: {// v-text-field
      type: Boolean,
      default: false
    },
    block: {// v-text-field: synthetic
      type: Boolean,
      default: false
    },
    prependIcon: {// v-text-field
      type: String,
      default: 'attach_file'
    }
  },
  data() {
    return {
      fileName: ""
    };
  },
  methods: {
    showFileSelector() {
      this.$refs.mediaInput.click();
    },
    uploadFile(e) {
      const file = e.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.$emit("change", file);
      }
    }
  }
};
</script>

<style scoped>
.media-file-btn {
  display: inline-block;
}
.media-file-btn input[type="file"] {
  position: absolute;
  filter: alpha(opacity=0);
  opacity: 0;
}
.media-text-field >>> .v-text-field__details {
  display: none;
}
</style>